import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button } from 'reactstrap';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { WRITE } from '../../../../../config/permissions';
import BaggageItemAdderModal from './BaggageItemAdderModal';
import Modal from '../../../../common/modal/Modal';
import { BAGGAGE_ADMINISTRATOR_MOVEMENT_ENDPOINT } from '../../../../../config/endpoints';

const BaggageManifestAddItem = ({ selectedItineraryId, disabled }) => {
  const [showModal, setShowModal] = useState(false);
  const [bodyModal, setBodyModal] = useState(null);
  const [titleModal, setTitleModal] = useState(null);

  const handleShowModal = () => setShowModal(true);

  const handleCloseModal = () => {
    setShowModal(false);
    setBodyModal(null);
    setTitleModal(null);
  };

  const handleShowAddBaggageItemModal = () => {
    setBodyModal(
      <BaggageItemAdderModal
        itineraryId={selectedItineraryId}
        onCancel={handleCloseModal}
        onSuccess={handleCloseModal}
      />,
    );
    handleShowModal();
    setTitleModal('Agregar Equipaje');
  };

  return (
    <>
      <Modal
        show={showModal}
        title={titleModal}
        body={bodyModal}
        onClickClose={handleCloseModal}
      />
      <Button
        color="success"
        type="button"
        className="mr-2"
        onClick={handleShowAddBaggageItemModal}
        disabled={disabled}
      >
        <i className="fa fa-plus" /> Agregar Equipaje
      </Button>
    </>
  );
};

BaggageManifestAddItem.propTypes = {
  selectedItineraryId: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
};

BaggageManifestAddItem.defaultProps = {
  disabled: false,
};

export default withEndpointAuthorization({
  url: BAGGAGE_ADMINISTRATOR_MOVEMENT_ENDPOINT,
  permissionType: WRITE,
  showForAllWhen: (props) => !props.isManifestPrinted,
})(BaggageManifestAddItem);
